/**
 * `routes/team/memberStatusPill.ts` — the People page's Status pill, as data
 * (#820 R2.3; split out for #2071, lead phone app B6).
 *
 * One rule for the laptop table (`MembersTableRow`) and the lead's phone
 * People screen (`memberapp/team/PeopleScreen`): an account-less manual
 * placeholder reads "no account" (the salient attribute — factual, not
 * deficiency-framed); everyone else reads their membership status, in the
 * success tone when active, neutral once they have left, warning otherwise.
 */
import type { MemberRow } from "./types";

export type MemberStatusTone = "success" | "neutral" | "warning";

export function memberStatusPill(member: Pick<MemberRow, "account_id" | "status">): {
  label: string;
  tone: MemberStatusTone;
} {
  const tone: MemberStatusTone =
    member.status === "active" ? "success" : member.status === "left" ? "neutral" : "warning";
  return { label: member.account_id === null ? "no account" : member.status, tone };
}
